<div>
	<div class="button-container">
		<bb-button icon="plus" (click)="createReactPage()" class="create-button">
			{{ 'REACT_CREATE_PAGE' | translate }}
		</bb-button>
		<h3><bb-info [contents]="'HELP.CREATE_REACT' | translate: {entity: entityType | translate}"></bb-info></h3>
	</div>

	<bb-table-container>
		<bb-table-header>
			<bb-table-header-cell property="label" [hideSorting]="true">{{ 'NAME' | translate }}</bb-table-header-cell>
			<bb-table-header-cell property="playoutname" [hideSorting]="true">{{ 'PLAYOUT' | translate }}
			</bb-table-header-cell>
			<bb-table-header-cell *ngIf="projectContextOptions" property="context" [hideSorting]="true">{{ 'CONTEXT' | translate }}
			</bb-table-header-cell>
			<bb-table-header-cell property="notifications" [hideSorting]="true">{{ 'NOTIFICATIONS' | translate }}
			</bb-table-header-cell>
			<bb-table-header-cell property="password_set" [hideSorting]="true">{{ 'PASSWORD' | translate }}
			</bb-table-header-cell>
			<bb-table-header-cell class="buttons"></bb-table-header-cell>
		</bb-table-header>

		<!-- (note: rows is set in AbstractListComponent) -->
		<bb-table-row *ngIf="rows?.length === 0">
			<bb-table-cell property="label" class="overflow dummy-row">
				<span>{{ 'NO_REACT_YET' | translate }}</span>
			</bb-table-cell>
			<bb-table-cell property="playoutname">&nbsp;</bb-table-cell>
			<bb-table-cell *ngIf="projectContextOptions" property="context">&nbsp;</bb-table-cell>
			<bb-table-cell property="notifications">&nbsp;</bb-table-cell>
			<bb-table-cell property="password_set">&nbsp;</bb-table-cell>
			<bb-table-cell class="buttons">&nbsp;</bb-table-cell>
		</bb-table-row>

		<bb-table-row *ngFor="let row of rows; let i = index; trackBy: trackBy" [row]="row" [colspan]="projectContextOptions ? 7 : 6">
			<bb-table-cell property="label" class="overflow">
				<span>{{ row.data.label}}</span>
			</bb-table-cell>
			<bb-table-cell property="playoutname" class="overflow">
				<span>{{ row.data.playoutname }}</span>
			</bb-table-cell>
			<bb-table-cell *ngIf="projectContextOptions" property="context" class="overflow">
				<span>{{ (projectContextOptions | filter : {'value': row.data.context})[0]?.label }}</span>
			</bb-table-cell>
			<bb-table-cell property="notifications">
				<i class="fa fa-check" *ngIf="row.data.notifications"></i>
			</bb-table-cell>
			<bb-table-cell property="password_set">
				<i class="fa fa-check" *ngIf="row.data.password_set"></i>
			</bb-table-cell>
			<bb-table-cell class="buttons">
				<a [title]="'DELETE' | translate" class="button" [ngClass]="{'disabled': !row.data.id}"
					(click)="deleteSingle(row.data)">
					<i class="fa fa-trash"></i>
				</a>
				<a [title]="'COPY' | translate" class="button" [ngClass]="{'disabled': !row.data.id}"
					(click)="copyUrlToClipboard(row.data.hash)">
					<i class="fa fa-copy"></i>
				</a>
				<a [title]="'REACT_OPEN_PAGE' | translate" class="button" [ngClass]="{'disabled': !row.data.id}"
					(click)="openReactPage(row.data.hash)">
					<i class="fa fa-eye"></i>
				</a>
				<a [title]="'REACT_EDIT_PAGE' | translate" class="button" data-cy="react-edit-button"
					(click)="row.quickEditing = !row.quickEditing">
					<i class="fa fa-pencil"></i>
				</a>
			</bb-table-cell>

			<!-- (note: quickedit and row.quickEditing used by bb-table-row) -->
			<div quickedit>
				<bb-react-quickedit [row]="row" *ngIf="row.quickEditing" [parentForm]="reactForm"
				[projectContextOptions]="projectContextOptions" (removed)="onItemRemoved(row, i)">
				</bb-react-quickedit>
			</div>
		</bb-table-row>
	</bb-table-container>

	<bb-table-pager></bb-table-pager>
</div>
